var _ellipse, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDatabase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.00033,
    cy: 3.33337,
    rx: 5.33333,
    ry: 2,
    stroke: "#242428"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 7.22803C5.06805 7.34859 5.51655 7.44787 6.00033 7.52131",
    stroke: "#242428",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 8C13.3337 9.10457 10.9458 10 8.00033 10C5.05481 10 2.66699 9.10457 2.66699 8",
    stroke: "#242428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 11.8947C5.06805 12.0152 5.51655 12.1145 6.00033 12.1879",
    stroke: "#242428",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3337 3.33337L13.3337 12.6667C13.3337 13.7713 10.9458 14.6667 8.00033 14.6667C5.05481 14.6667 2.66699 13.7713 2.66699 12.6667L2.66699 3.33337",
    stroke: "#242428"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDatabase);
export default __webpack_public_path__ + "static/media/icon-database.4a9d0919bbf899bb5d4c2876484ae49a.svg";
export { ForwardRef as ReactComponent };